export default __webpack_public_path__ + "static/media/entertainment-icon.396bf43e.png";